import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "AdminManagement" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
